<template>
  <Modal
    class="tenant-confirm-modal"
    modalType="large-modal"
    ref="tenantConfirmModal"
    modalId="tenant-confirm-contact-modal"
  >
    <div slot="content">
      <div class="tennat-confirm-modal__text font-bold">
        <p
          class="text"
          v-html="$t(`tenantConfirms.${regionName}.part1`, [companyName])"
        />
        <p
          class="text"
          v-html="$t(`tenantConfirms.${regionName}.part2`, [companyName])"
        />
      </div>
    </div>
    <div slot="btns">
      <button
        type="button"
        class="btn btn--darkblue"
        @click="close"
      >{{ $t('action.cancel') }}</button>
      <button
        type="button"
        class="btn btn--orange"
        @click="confirm"
      >{{ $t('action.confirm') }}</button>
    </div>
  </Modal>
</template>
<script>
import lodash from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import Modal from '@/controls/Modal'

import notification from '@/utils/notification'
import { getSubsidiaryTextArray } from '@/api/postman/util'

export default {
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('ccd', ['currentTenancy']),
    ...mapGetters('regions', ['regionName']),
    companyName () {
      const subsidiary = lodash.get(this.currentTenancy, ['physicalSite', 'subsidiary'], '')
      const subsidiaryArray = getSubsidiaryTextArray(subsidiary)
      const result = lodash.get(subsidiaryArray, [0], '')
      return result
    },
  },
  methods: {
    ...mapActions('ccd', ['confirmContacts']),
    open () {
      this.$refs.tenantConfirmModal.open()
    },
    close () {
      this.$refs.tenantConfirmModal.close()
    },
    confirm () {
      this.confirmContacts()
      notification.fireNotification(true, this.$t('success'))
      this.$refs.tenantConfirmModal.close()
    },
  },
}
</script>
